import { fonts } from "../../../../styles/fonts";


const restDayWrapper = {
    minHeight: "60vh",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
}

const restImage = {

}

const restDayTitle = {
    marginTop: 20,
    color: "#333333",
    fontFamily: fonts.regularFont,
    fontSize: 30
}


export {
    restDayTitle,
    restDayWrapper,
    restImage
}